// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"100":"WaterUseOverview","608":"scadaEditor"}[chunkId] + "." + {"100":"14cc600c","608":"0865340f"}[chunkId] + ".chunk.css";
};